export const phoneRegex = /^(?:[+][0-9]{2}[-\s.]?)?[0-9]{3}[-\s.]?[0-9]{3}[-\s.]?[0-9]{3}$/;
